/**
 * Admin Components - Shared constants and utilities
 * 
 * Extracted components:
 * - SettingsTab.jsx (~300 lines)
 * - SpecialsTab.jsx (~310 lines)
 * - CampaignsTab.jsx (~580 lines)
 */

import { API, getAuthHeaders } from '@/utils/api';

export { API, getAuthHeaders };

// Main categories
export const mainCategories = ['coffee', 'breakfast', 'lunch', 'sweets'];

// Drinks subcategories  
export const drinksCategories = ['iced-drinks', 'smoothies-blends', 'fresh-mixed-juice', 'milk-shakes'];

// All categories for filtering
export const categories = [...mainCategories, ...drinksCategories];

// Category labels for display
export const categoryLabels = {
  'coffee': 'Coffee',
  'breakfast': 'Breakfast',
  'lunch': 'Lunch', 
  'sweets': 'Sweets',
  'iced-drinks': 'Iced Drinks',
  'smoothies-blends': 'Smoothies & Blends',
  'fresh-mixed-juice': 'Fresh Mixed Juice',
  'milk-shakes': 'Milk Shakes'
};

export const orderStatuses = ['pending', 'confirmed', 'preparing', 'ready', 'completed', 'cancelled'];

export const statusColors = {
  pending: 'bg-yellow-100 text-yellow-800',
  confirmed: 'bg-blue-100 text-blue-800',
  preparing: 'bg-purple-100 text-purple-800',
  ready: 'bg-green-100 text-green-800',
  completed: 'bg-gray-100 text-gray-600',
  cancelled: 'bg-red-100 text-red-800'
};

// Default coffee modifiers for new menu items
export const DEFAULT_COFFEE_MODIFIERS = [
  { name: 'Milk Type', options: ['Regular Milk', 'Oat Milk', 'Almond Milk', 'Soy Milk', 'Coconut Milk'], price_adjustment: 1.0 },
  { name: 'Ice Level', options: ['Regular Ice', 'Less Ice', 'No Ice'], price_adjustment: 0.0 },
  { name: 'Sweetness', options: ['Regular', 'Less Sugar', 'No Sugar'], price_adjustment: 0.0 }
];

export const DEFAULT_COFFEE_SIZES = [
  { name: 'Small', price: 6.80 },
  { name: 'Large', price: 8.80 }
];
